<script setup lang="ts">
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

export interface TableBaseProperties extends PrimitiveProps {
  containerClass?: HTMLAttributes['class']
  tableClass?: HTMLAttributes['class']
}

const properties = defineProps<TableBaseProperties>()
</script>

<template>
  <Primitive v-bind="$attrs" :as :as-child class="atabix-table-container">
    <slot name="before-table" />
    <slot name="table">
      <table :class="cn('atabix-table', properties.tableClass)">
        <slot />
      </table>
    </slot>
  </Primitive>
</template>

<style lang="scss">
.atabix-table-container {
  @apply relative;
  @apply w-full;

  .atabix-table {
    @apply w-full;
    @apply border-spacing-0;
  }
}
</style>
